import React from "react";
import noImage from "../data/images/no-image4.jpeg";
import { useStateContext } from "../contexts/ContextProvider";

const Avatar = (props) => {
  const { activeMenu, setActiveMenu } = useStateContext();
  const { user } = props;

  const handleActiveMenu = () => setActiveMenu(!activeMenu);

  return (
    <div className="cursor-pointer" onClick={handleActiveMenu}>
      <img
        src={
          user.avatar instanceof Blob
            ? URL.createObjectURL(user.avatar)
            : user.avatar || noImage
          //remove this logic once image handling is setup
        }
        alt={`${user.firstName}`}
        className="h-12 w-12 object-cover rounded-full"
      />
    </div>
  );
};

export default Avatar;
